import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { List } from '@phosphor-icons/react'

import Sidebar from '../../components/Sidebar/Sidebar'

import './DashboardLayout.scss';

export default function DashboardLayout() {
  const location = useLocation()

  const [sidebarOpen, setSidebarOpen] =
    useState(false)

  /* ========================================
     AUTO CLOSE SIDEBAR ON ROUTE CHANGE
  ======================================== */

  useEffect(() => {
    setSidebarOpen(false)
  }, [location.pathname])

  /* ========================================
     PREVENT BODY SCROLL WHEN SIDEBAR OPEN
  ======================================== */

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [sidebarOpen])

  return (
    <>
      {/* ========================================
          OVERLAY
      ======================================== */}

      <div
        className={`sidebar-overlay ${
          sidebarOpen ? 'active' : ''
        }`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* ========================================
          LAYOUT
      ======================================== */}

      <div className="dashboard-layout">
        {/* ========================================
            SIDEBAR
        ======================================== */}

        <Sidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        {/* ========================================
            MAIN CONTENT
        ======================================== */}

        <div className="dashboard-main">
          {/* ========================================
              MOBILE / TABLET NAVBAR
          ======================================== */}

          <header className="mobile-navbar">
            <button
              type="button"
              className="mobile-navbar__menu"
              onClick={() =>
                setSidebarOpen(!sidebarOpen)
              }
              aria-label="Toggle sidebar"
            >
              <List size={24} weight="bold" />
            </button>

            {/* <div className="mobile-navbar__title">
              Dashboard
            </div> */}
          </header>

          {/* ========================================
              PAGE CONTENT
          ======================================== */}

          <main className="dashboard-content">
            <div className="dashboard-container">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </>
  )
}